"use client";

import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { Section } from "@/components/ui/Section";
import { Typography } from "@/components/ui/Typography";
import { env } from "@/lib/environment";

interface Template {
  id: string;
  title: string;
  image: string;
  category: string[];
  editUrl: string;
}
const baseUrl = `${env.NEXT_PUBLIC_CDN_URL}/images/templates`;

const templates: Template[] = [
  {
    id: "supersale-newyear",
    title: "Super Sale - New Year",
    image: `${baseUrl}/holiday/supersale-newyear.O47mNQE1U7pD.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/657963e0b335c80c0800cbe1",
  },
  {
    id: "newyear-neonparty",
    title: "New Year Neon Party",
    image: `${baseUrl}/holiday/newyear-neonparty.wBjuY58r6IOx.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/657b032feb818dc3cf39569c",
  },
  {
    id: "newyear-evemusic",
    title: "New Year's Eve Music Party",
    image: `${baseUrl}/holiday/newyear-evemusic.ZrewDdIyHVHT.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6579ac97b335c80c08019562",
  },
  {
    id: "healthcare-portrait-2",
    title: "World Health Day",
    image: `${baseUrl}/healthcare/healthcare-portrait-2.OxUQc-HIFQR5.webp`,
    category: ["all", "healthcare"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6405999af0f3a50770453ce4",
  },
  {
    id: "healthcare-landscape-1",
    title: "Happiness Chemical",
    image: `${baseUrl}/healthcare/healthcare-landscape-1.__vPy5mf8fPg.webp`,
    category: ["all", "healthcare"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/640f27a3a590889f0d0a7cd3",
  },
  {
    id: "healthcare-landscape-2",
    title: "Medic Healthcare",
    image: `${baseUrl}/healthcare/healthcare-landscape-2.sqoiZsd0quy5.webp`,
    category: ["all", "healthcare"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/640aeb04d6566e60a72b32fb",
  },
  {
    id: "healthcare-portrait-1",
    title: "Hospital Wayfinding",
    image: `${baseUrl}/healthcare/healthcare-portrait-1.wUnLRHdKUqUI.webp`,
    category: ["all", "healthcare"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/64886f2035caf90b587b6142",
  },
  {
    id: "healthcare-landscape-3",
    title: "Medic Healthcare Center",
    image: `${baseUrl}/healthcare/healthcare-landscape-3.uam3exi_YtZB.webp`,
    category: ["all", "healthcare"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/64004dc7e1b0efa34fa64a0b",
  },
  {
    id: "healthcare-landscape-4",
    title: "Health Precaution",
    image: `${baseUrl}/healthcare/healthcare-landscape-4.u-WRow8q2uQB.webp`,
    category: ["all", "healthcare"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6405f9a047b75a04045792af",
  },
  {
    id: "healthcare-landscape-5",
    title: "Dental Care",
    image: `${baseUrl}/healthcare/healthcare-landscape-5.NYq54HF_tmx-.webp`,
    category: ["all", "healthcare"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6481b72735caf90b586598d6",
  },
  {
    id: "healthcare-portrait-3",
    title: "Hospital Conference",
    image: `${baseUrl}/healthcare/healthcare-portrait-3.Zg9Ffoi-j2Mx.webp`,
    category: ["all", "healthcare"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6489bb5335caf90b58912a54",
  },
  {
    id: "newyear-sale",
    title: "New Year Sale",
    image: `${baseUrl}/holiday/newyear-sale.jyJl9sVHcZko.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/657ab6f7eb818dc3cf339ad1",
  },
  {
    id: "newyear-welcomeparty",
    title: "New Year Welcome Party",
    image: `${baseUrl}/holiday/newyear-welcomeparty.Pv5wJsddbv-F.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/65782caacbffeca5dfa46898",
  },
  {
    id: "christmas-bigburgersale",
    title: "Christmas Big Burger Sale",
    image: `${baseUrl}/holiday/christmas-bigburgersale.9bRzc_DaOe5S.webp`,
    category: ["all", "holiday", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6579a45bcbffeca5dfb4c506",
  },
  {
    id: "restaurant-landscape-1",
    title: "Your Cocktail Bar",
    image: `${baseUrl}/restaurant-landscape-1.ObJSUa6tymxl.webp`,
    category: ["all", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/63e499a64863d72a5e7a3893",
  },
  {
    id: "restaurant-landscape-2",
    title: "Restro Menu",
    image: `${baseUrl}/restaurant-landscape-2.MR58LxPQUlxh.webp`,
    category: ["all", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/646f14f91753dd397d1b2093",
  },
  {
    id: "restaurant-landscape-3",
    title: "Sketch Menu",
    image: `${baseUrl}/restaurant-landscape-3.1T5gyzKrIUCv.webp`,
    category: ["all", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/64706aed2213457817079286",
  },
  {
    id: "restaurant-landscape-4",
    title: "Menu Special",
    image: `${baseUrl}/restaurant-landscape-4.lLF9lZbW3p8X.webp`,
    category: ["all", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/647d99ce8d288e64205fcfd8",
  },
  {
    id: "restaurant-portrait-1",
    title: "Daily Food Guide",
    image: `${baseUrl}/restaurant-portrait-1.wkGu1AJKQk05.webp`,
    category: ["all", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6409e99ae3e4624dcbe037ea",
  },
  {
    id: "restaurant-portrait-2",
    title: "Hygienic Food",
    image: `${baseUrl}/restaurant-portrait-2.rqTTGTfxuLYx.webp`,
    category: ["all", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6419774b7c2702fd58d85776",
  },
  {
    id: "restaurant-portrait-3",
    title: "Today's Special Dish",
    image: `${baseUrl}/restaurant-portrait-3.c4G1dTesjf4g.webp`,
    category: ["all", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/64072b9247b75a0404585278",
  },
  {
    id: "restaurant-portrait-4",
    title: "Dish Of The Day Restaurant",
    image: `${baseUrl}/restaurant-portrait-4.sk_hZfqjNfwz.webp`,
    category: ["all", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6406e1f91b224120af19c2be",
  },
  {
    id: "restaurant-portrait-5",
    title: "Salad Restaurant Menu",
    image: `${baseUrl}/restaurant-portrait-5.r_GUOt6ZjBPe.webp`,
    category: ["all", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6405f38d35e91011833e3ff8",
  },
  {
    id: "black-salelandscape",
    title: "Black Friday Sale",
    image: `${baseUrl}/holiday/black-salelandscape.jcuq-v0z_hwj.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/655c646572f3a9504fbb8cc1",
  },
  {
    id: "blackfriday-landscape1",
    title: "Black Friday Deals",
    image: `${baseUrl}/holiday/blackfriday-landscape1.Z1lqYZMyTnKK.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6540b5228e36d7ce4e93b813",
  },
  {
    id: "blackfriday-landscape2",
    title: "Black Friday Special",
    image: `${baseUrl}/holiday/blackfriday-landscape2.sx2X5VL9pq6G.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6540b8728e36d7ce4e93bd12",
  },
  // {
  //   id: "blackfriday-sale1",
  //   title: "Black Friday Mega Sale",
  //   image: `${baseUrl}/holiday/blackfriday-sale1.3QD_bbONhtXM.webp`,
  //   category: ["all", "holiday"],
  //   editUrl: "https://console.pickcel.com/suite/artboard/#/657ab6f7eb818dc3cf339ad1",
  // },
  // {
  //   id: "blackfriday-sales",
  //   title: "Black Friday Sales",
  //   image: `${baseUrl}/holiday/blackfriday-sales.sqDmVdBz84RT.webp`,
  //   category: ["all", "holiday"],
  //   editUrl: "https://console.pickcel.com/suite/artboard/#/641831597c2702fd58d6d44e",
  // },
  {
    id: "boxingday-sale",
    title: "Boxing Day Sale",
    image: `${baseUrl}/holiday/boxingday-sale.n6suAMvRSWMO.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/657a9df4e9daab8834481310",
  },
  {
    id: "christmas-menu",
    title: "Christmas Menu",
    image: `${baseUrl}/holiday/christmas-menu.73eIFoQqblsx.webp`,
    category: ["all", "holiday", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6577fdd8b335c80c08e8a0ed",
  },
  {
    id: "christmas-party",
    title: "Christmas Party",
    image: `${baseUrl}/holiday/christmas-party.jSuNjyATbxNu.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6579508ecbffeca5dfb35625",
  },
  {
    id: "christmas-weekendsale",
    title: "Christmas Weekend Sale",
    image: `${baseUrl}/holiday/christmas-weekendsale.b0ldllw97HNE.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/65786598b335c80c08fe27c9",
  },
  {
    id: "christmasrestaurant-menu",
    title: "Christmas Restaurant Menu",
    image: `${baseUrl}/holiday/christmasrestaurant-menu.SdYRManmQ8sI.webp`,
    category: ["all", "holiday", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/65770d0ecbffeca5df97e7dc",
  },
  {
    id: "coroparate-lunch",
    title: "Corporate Lunch",
    image: `${baseUrl}/holiday/coroparate-lunch.p6nTQHlYF2xV.webp`,
    category: ["all", "holiday", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/654b39302ec877793882d297",
  },
  {
    id: "endOfseason-sale",
    title: "End Of Season Sale",
    image: `${baseUrl}/holiday/endOfseason-sale.uRr439FOs94T.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/657afc51e9daab883450aaff",
  },
  // {
  //   id: "friday-sale",
  //   title: "Friday Sale",
  //   image: `${baseUrl}/holiday/friday-sale.n3PHtcf6XZCW.webp`,
  //   category: ["all", "holiday"],
  //   editUrl: "https://console.pickcel.com/suite/artboard/#/657ab6f7eb818dc3cf339ad1",
  // },
  {
    id: "merrychristmas-happynewyear",
    title: "Merry Christmas Happy New Year",
    image: `${baseUrl}/holiday/merrychristmas-happynewyear.2ZFt6zC8j63r.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/657807f1b335c80c08ed61a1",
  },
  {
    id: "thanks-giving1",
    title: "Thanksgiving Celebration",
    image: `${baseUrl}/holiday/thanks-giving1.XsmwZ-IyVaH8.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/654b2c612ec877793882b2b8",
  },
  {
    id: "thanlsgiving-landscape",
    title: "Thanksgiving Landscape",
    image: `${baseUrl}/holiday/thanlsgiving-landscape.7TdYmLa4_go4.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6540fe468e36d7ce4e93edda",
  },
  {
    id: "thanksgiving-qutes",
    title: "Thanksgiving Quotes",
    image: `${baseUrl}/holiday/thanksgiving-qutes.PZAtDXWI8jf7.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/654b30e02ec877793882c800",
  },
  {
    id: "thanks-giving-event-detail",
    title: "Thanksgiving Event Details",
    image: `${baseUrl}/holiday/thanks-giving event-detail.3qZQlBrK372c.webp`,
    category: ["all", "holiday"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/654b3f20341f5eb957dc8796",
  },
  // {
  //   id: "thankgiving-dinner",
  //   title: "Thanksgiving Dinner",
  //   image: `${baseUrl}/holiday/thankgiving-dinner.zkFMt8-PmmQM.webp`,
  //   category: ["all", "holiday", "restaurant"],
  //   editUrl: "https://console.pickcel.com/suite/artboard/#/657ab6f7eb818dc3cf339ad1",
  // },
  {
    id: "retail-landscape-1",
    title: "Fashion New Product",
    image: `${baseUrl}/retail/retail-landscape-1.zKeU3RoTbsfw.webp`,
    category: ["all", "retail"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/647707b4a561e94816dbcf10",
  },
  {
    id: "retail-portrait-1",
    title: "End Of Season Sale",
    image: `${baseUrl}/retail/retail-portrait-1.gV0i9_gXeCIo.webp`,
    category: ["all", "retail"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6418046d7c2702fd58d6af9b",
  },
  {
    id: "retail-landscape-2",
    title: "Sales Fashion Banner",
    image: `${baseUrl}/retail/retail-landscape-2.fdaenWoTZjzq.webp`,
    category: ["all", "retail"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/64804ace98a1bbd6095774de",
  },
  {
    id: "retail-portrait-5",
    title: "Product Launch",
    image: `${baseUrl}/retail/retail-portrait-5.d8DgF-C_DPnH.webp`,
    category: ["all", "retail"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/640b01bb47b75a04045a9e35",
  },
  {
    id: "retail-landscape-4",
    title: "Shoe banner",
    image: `${baseUrl}/retail/retail-landscape-4.1-d-Z0lAHwiS.webp`,
    category: ["all", "retail"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/64771d620e12dce01de21faf",
  },
  {
    id: "retail-landscape-3",
    title: "Black Friday Sale",
    image: `${baseUrl}/retail/retail-landscape-3.Z07XF_WQ_nKu.webp`,
    category: ["all", "retail"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/63f8b0107930b24146a440e9",
  },
  {
    id: "retail-portrait-2",
    title: "Grand Opening",
    image: `${baseUrl}/retail/retail-portrait-2.DOOyUqmwuCRz.webp`,
    category: ["all", "retail"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/641449a77c2702fd58d325bf",
  },
  {
    id: "retail-portrait-3",
    title: "Black Friday Sale",
    image: `${baseUrl}/retail/retail-portrait-3.rRPEht02OniH.webp`,
    category: ["all", "retail"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/64181363a138d65c62938743",
  },
  {
    id: "retail-portrait-4",
    title: "Product Showcase",
    image: `${baseUrl}/retail/retail-portrait-4.w-0jNi6Pi_Lb.webp`,
    category: ["all", "retail"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/64182e563136605c70263bcc",
  },
  {
    id: "retail-portrait-6",
    title: "Pawn Shop",
    image: `${baseUrl}/retail/retail-portrait-6.CekhRd1eqxMp.webp`,
    category: ["all", "retail"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6476ee22c7b4d5c3d05de7dd",
  },
  {
    id: "hospitality-landscape-1",
    title: "Hotel Hospitality Offer",
    image: `${baseUrl}/hospitality/hospitality-landscape-1.1gV1cfhZ6ImK.webp`,
    category: ["all", "hospitality"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6474ad6222134578170bffbe",
  },
  {
    id: "hospitality-landscape-2",
    title: "Explore Belgium",
    image: `${baseUrl}/hospitality/hospitality-landscape-2.-Tusa42eCqnK.webp`,
    category: ["all", "hospitality"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6499624f756ed2103dfaaa20",
  },
  {
    id: "hospitality-landscape-3",
    title: "Luxury Hotel",
    image: `${baseUrl}/hospitality/hospitality-landscape-3.YXc7vHrN4CVD.webp`,
    category: ["all", "hospitality"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6479df3b64f3889190895b16",
  },
  // {
  //   id: "hospitality-landscape-4",
  //   title: "Grand Opening",
  //   image: `${baseUrl}/hospitality/hospitality-landscape-4.yjUYMQnqt_0K.webp`,
  //   category: ["all", "hospitality"],
  //   editUrl: "https://console.pickcel.com/suite/artboard/#/6479df3b64f3889190895b16",
  // },
  {
    id: "hospitality-portrait-1",
    title: "Enjoy The Paradise",
    image: `${baseUrl}/hospitality/hospitality-portrait-1.NTdrjspVl-_6.webp`,
    category: ["all", "hospitality"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/646205aaa7a1674d36b0cec4",
  },
  {
    id: "hospitality-portrait-2",
    title: "Boxing Day Sale",
    image: `${baseUrl}/hospitality/hospitality-portrait-2.YaiBw3NQ7EDi.webp`,
    category: ["all", "hospitality"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6479cf6564f388919087be07",
  },
  {
    id: "hospitality-portrait-3",
    title: "Enjoy Breakfast",
    image: `${baseUrl}/hospitality/hospitality-portrait-3.3dRVV8cHhWym.webp`,
    category: ["all", "hospitality", "restaurant"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/648822fe35caf90b58785f6e",
  },
  {
    id: "hospitality-portrait-4",
    title: "It's Time to Travel",
    image: `${baseUrl}/hospitality/hospitality-portrait-4.jQl6NGJFdPwc.webp`,
    category: ["all", "hospitality"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/64831b6f98a1bbd609640985",
  },
  {
    id: "hospitality-portrait-5",
    title: "Enjoy Holiday With Us",
    image: `${baseUrl}/hospitality/hospitality-portrait-5.d9sBYpyVwymO.webp`,
    category: ["all", "hospitality"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/648822fe35caf90b58785f6e",
  },
  {
    id: "hospitality-portrait-6",
    title: "Time To Travel",
    image: `${baseUrl}/hospitality/hospitality-portrait-6.BZDeKPsOYpwI.webp`,
    category: ["all", "hospitality"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/649983db131037e936eca9d2",
  },
  {
    id: "healthcare-portrait-4",
    title: "Medical Services",
    image: `${baseUrl}/healthcare/healthcare-portrait-4.eFuuSa1yoBtj.webp`,
    category: ["all", "healthcare"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/64993c3e756ed2103dfa43a1",
  },
  // {
  //   id: "healthcare-portrait-5",
  //   title: "Healthcare Solutions",
  //   image: `${baseUrl}/healthcare/healthcare-portrait-5.JLY_sl_Dhg-A.webp`,
  //   category: ["all", "healthcare"],
  //   editUrl: "https://console.pickcel.com/suite/artboard/#/6489bb5335caf90b58912a54",
  // },
  {
    id: "healthcare-portrait-6",
    title: "Medical Center",
    image: `${baseUrl}/healthcare/healthcare-portrait-6.ljxlpGXXHD10.webp`,
    category: ["all", "healthcare"],
    editUrl: "https://console.pickcel.com/suite/artboard/#/6405ce458158520d61ed8a80",
  },
];

const filters = [
  {
    id: "all",
    name: "All",
    icon: (
      <svg className="w-full h-full" viewBox="0 0 32 32" fill="none">
        <path
          d="M5 8.5H27M5 13.5H27M5 18.5H27M5 23.5H27"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "restaurant",
    name: "Digital Menu Board",
    icon: (
      <svg className="w-full h-full" viewBox="0 0 32 32" fill="none">
        <path
          d="M7 28.1661L9 26.6661C9 26.6661 9 24.1661 10.5 23.6661C10.5 22.8204 10.5 22.1535 10.5 21.6654C10.5 21.1131 10.9477 20.6661 11.5 20.6661C12.0523 20.6661 12.5 21.1138 12.5 21.6661V23.6661L19.3076 20.4892C19.7233 20.2953 20.2159 20.382 20.5403 20.7064C21.0331 21.1993 20.9436 22.0216 20.3563 22.3969L15.5 25.5C14.5 27.5 12.5 28.1661 11.5 28.6661C9.78079 29.5257 8.5 30.6661 8.5 30.6661M14 3C14 3 14 1 16 1C18 1 18 3 18 3M5.59073 14.5C6.01374 10.8354 7.92626 4.70451 16 4.83231C24.0228 4.9593 25.9619 10.9119 26.4011 14.5M5.5 17.1661H5C4.44772 17.1661 4 17.6138 4 18.1661C4 18.7184 4.44772 19.1661 5 19.1661H27C27.5523 19.1661 28 18.7184 28 18.1661C28 17.6138 27.5523 17.1661 27 17.1661H26.5H16H5.5Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    link: "/digital-signage-templates/digital-menu-board-templates/",
  },
  {
    id: "retail",
    name: "Retail",
    icon: (
      <svg className="w-full h-full" viewBox="0 0 32 32" fill="none">
        <path
          d="M4.15385 14.9231V27.3077M4.15385 27.3077H3C2.44772 27.3077 2 27.7554 2 28.3077V29C2 29.5523 2.44772 30 3 30H29C29.5523 30 30 29.5523 30 29V28.3077C30 27.7554 29.5523 27.3077 29 27.3077H27.8462M4.15385 27.3077H19.7692H25.6923H27.8462M27.8462 27.3077V14.9231M27.8462 4.15385V3C27.8462 2.44772 27.3984 2 26.8462 2H5.15385C4.60156 2 4.15385 2.44772 4.15385 3V4.15385M27.8462 4.15385H22.4615M27.8462 4.15385L29.4312 9.70162C29.761 10.8559 29.2219 12.0813 28.1482 12.6182C27.3031 13.0408 26.2917 12.9496 25.5358 12.3826L24.6154 11.6923M4.15385 4.15385L2.56877 9.70162C2.23898 10.8559 2.77806 12.0813 3.85178 12.6182C4.69691 13.0408 5.70826 12.9496 6.46418 12.3826L7.38462 11.6923M4.15385 4.15385H9.53846M9.53846 4.15385L7.38462 11.6923M9.53846 4.15385H13.8462M7.38462 11.6923C8.87154 13.1792 11.2823 13.1792 12.7692 11.6923M13.8462 4.15385L12.7692 11.6923M13.8462 4.15385H18.1538M12.7692 11.6923C14.5535 13.4766 17.4465 13.4766 19.2308 11.6923M18.1538 4.15385L19.2308 11.6923M18.1538 4.15385H22.4615M19.2308 11.6923C20.4133 13.1704 22.5791 13.3892 24.0333 12.1774L24.6154 11.6923M22.4615 4.15385L24.6154 11.6923M18.6923 24.6154V17.5385C18.6923 16.9862 19.14 16.5385 19.6923 16.5385H23.6154C24.1677 16.5385 24.6154 16.9862 24.6154 17.5385V24.6154M15.4615 17.5385V21.4615C15.4615 22.0138 15.0138 22.4615 14.4615 22.4615H8.38462C7.83233 22.4615 7.38462 22.0138 7.38462 21.4615V17.5385C7.38462 16.9862 7.83233 16.5385 8.38462 16.5385H14.4615C15.0138 16.5385 15.4615 16.9862 15.4615 17.5385Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "healthcare",
    name: "Healthcare",
    icon: (
      <svg className="w-full h-full" viewBox="0 0 32 32" fill="none">
        <path
          d="M10.4444 5.84314V4C10.4444 2.89543 11.3399 2 12.4444 2H19.5556C20.6601 2 21.5556 2.89543 21.5556 4V5.84314M13.7778 17.3725V15.0784C13.7778 14.5261 14.2255 14.0784 14.7778 14.0784H16H17.2222C17.7745 14.0784 18.2222 14.5261 18.2222 15.0784V17.3725H20.5556C21.1078 17.3725 21.5556 17.8203 21.5556 18.3725V19.5686V20.7647C21.5556 21.317 21.1078 21.7647 20.5556 21.7647H18.2222V24.0588C18.2222 24.6111 17.7745 25.0588 17.2222 25.0588H14.7778C14.2255 25.0588 13.7778 24.6111 13.7778 24.0588V21.7647H11.4444C10.8922 21.7647 10.4444 21.317 10.4444 20.7647V18.3725C10.4444 17.8203 10.8922 17.3725 11.4444 17.3725H13.7778ZM31 10.5882V28C31 29.1046 30.1046 30 29 30H3C1.89543 30 1 29.1046 1 28V10.5882C1 9.48367 1.89543 8.58824 3 8.58824H29C30.1046 8.58824 31 9.48367 31 10.5882Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "hospitality",
    name: "Hospitality",
    icon: (
      <svg className="w-full h-full" viewBox="0 0 32 32" fill="none">
        <path
          d="M1 27.8824V29C1 29.5523 1.44772 30 2 30H3.75C4.30228 30 4.75 29.5523 4.75 29V27.8824M5.82143 12V10.3529C5.82143 9.80066 6.26914 9.35294 6.82143 9.35294H13.9286C14.4809 9.35294 14.9286 9.80066 14.9286 10.3529V12M17.0714 12V10.3529C17.0714 9.80066 17.5191 9.35294 18.0714 9.35294H25.1786C25.7309 9.35294 26.1786 9.80066 26.1786 10.3529V12M3.14286 12V5C3.14286 3.89543 4.03829 3 5.14286 3H26.8571C27.9617 3 28.8571 3.89543 28.8571 5V12M4.21429 22.5882H16H28.8571M31 27.8824V29C31 29.5523 30.5523 30 30 30H28.25C27.6977 30 27.25 29.5523 27.25 29V27.8824M1 25.7647H31V16.6471C31 15.5425 30.1046 14.6471 29 14.6471H3C1.89543 14.6471 1 15.5425 1 16.6471V25.7647Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "holiday",
    name: "Holiday",
    icon: (
      <svg className="w-full h-full" viewBox="0 0 32 32" fill="none">
        <path
          d="M16 8L18 12L22 13L19 16L20 20L16 18L12 20L13 16L10 13L14 12L16 8Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

interface TemplatesGalleryProps {
  defaultCategory?: string;
  disableFilterLinks?: boolean;
}

export default function TemplatesGallery({
  defaultCategory = "all",
  disableFilterLinks = false,
}: TemplatesGalleryProps = {}) {
  const [activeFilter, setActiveFilter] = useState(defaultCategory);
  const [showAll, setShowAll] = useState(false);

  const filteredTemplates =
    activeFilter === "all"
      ? templates
      : templates.filter(template => template.category.includes(activeFilter));

  const displayedTemplates = showAll ? filteredTemplates : filteredTemplates.slice(0, 12);

  return (
    <Section variant="default" className="bg-gray-50" id="templates">
      <div className="text-center mb-12 max-w-3xl mx-auto">
        <Typography as="h2" variant="h2" id="new-function" className="scroll-mt-24">
          Instant Access to Industry-Tailored Templates
        </Typography>
      </div>

      {/* Filters */}
      <div className="flex justify-center items-center mb-12 w-full">
        <div className="relative w-full md:w-auto">
          {/* Scroll indicator gradients for mobile */}
          <div className="absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-white/80 to-transparent pointer-events-none z-10 md:hidden rounded-l-full" />
          <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white/80 to-transparent pointer-events-none z-10 md:hidden rounded-r-full" />

          <div className="flex items-center bg-[#f6f6f6] p-2 gap-2 rounded-full overflow-x-auto scrollbar-hide snap-x snap-mandatory scroll-smooth max-w-full md:max-w-none w-full md:w-auto">
            {filters.map(filter => {
            const isActive = activeFilter === filter.id;
            const className = `flex flex-row items-center gap-2 px-4 py-2 rounded-full transition-all flex-shrink-0 snap-center ${
              isActive
                ? "bg-primary text-white border-primary"
                : " text-text-primary border-gray-200 hover:bg-primary hover:text-white"
            }`;

            const content = (
              <>
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <div className="w-full h-full">{filter.icon}</div>
                </div>
                <span className="font-medium text-xs md:text-sm">{filter.name}</span>
              </>
            );

            return filter.link && !disableFilterLinks ? (
              <Link key={filter.id} href={filter.link} className={className}>
                {content}
              </Link>
            ) : (
              <button
                key={filter.id}
                type="button"
                onClick={() => {
                  setActiveFilter(filter.id);
                  setShowAll(false);
                }}
                className={className}
              >
                {content}
              </button>
            );
          })}
          </div>
        </div>
      </div>

      {/* Templates Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 gap-y-3 mb-8">
        {displayedTemplates.map(template => (
          <div key={template.id} className="group transition-all duration-300 h-[280px]">
            <div className="relative w-full overflow-hidden h-[70%] group">
              <Image
                src={template.image}
                alt={template.title}
                title={template.title}
                fill
                className="object-cover absolute inset-0 blur-sm brightness-90"
                loading="lazy"
              />
              <Image
                src={template.image}
                alt={template.title}
                title={template.title}
                fill
                className="object-contain absolute inset-0 transition-transform duration-300 z-[1] group-hover:scale-105 object-center"
                loading="lazy"
              />
              <div className="absolute right-2 bottom-2 transition-all duration-300 flex items-center justify-center z-30">
                <Link
                  href={template.editUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:scale-110 transform bg-secondary rounded-sm p-2 shadow-lg"
                >
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                    />
                  </svg>
                </Link>
              </div>
            </div>
            <div className="p-4 text-center">
              <Typography as="h3" variant="h6" className="text-text-primary group-hover:text-accent group-hover:underline font-semibold">
                {template.title}
              </Typography>
            </div>
          </div>
        ))}
      </div>

      {/* View More/Less Buttons */}
      {filteredTemplates.length > 12 && (
        <div className="text-center">
          <button
            type="button"
            onClick={() => setShowAll(!showAll)}
            className="px-6 py-3 border-2 border-primary text-primary rounded-lg hover:bg-primary hover:text-white transition-colors font-medium"
          >
            {showAll ? "View Less" : "View More"}
          </button>
        </div>
      )}
    </Section>
  );
}
